
import { defineComponent } from "@vue/runtime-core";
import authFooter from "@/modules/auth/components/authFooterComponent.vue"
import ResponseData from "../../../_models/ResponseData"
import XarcadeAccountService from "../../../services/XarcadeAccountService";
import { createToast } from 'mosha-vue-toastify';
import 'mosha-vue-toastify/dist/style.css'

import { Helper } from "@/utils/Helper";

export default defineComponent({
  name: "viewAuthChangePassword",
  components:{
    authFooter
  },
  data() {
    return {
      password: "",
      confirm: "",
      activeSection: "confirmPassword",
    }
  },
  methods: {
    changePassword() {
      this.activeSection = 'loadingConfirmPassword';

      let userId = this.$route.query.id;
      let token = this.$route.query.token!.toString();
      let data = new FormData();

      data.append('Token', token);
      data.append('Password', this.password);
      data.append('ConfirmPassword', this.confirm);

      XarcadeAccountService.resetPassword(userId, data)
        .then((response: ResponseData) => {
          this.activeSection = 'confirmPasswordSuccess';
          // if (response.data.message['Password reset success']) {
          //   console.log(response);
          //   this.activeSection = 'confirmPasswordSuccess';
          // } else {
          //   console.log(response);
          //   this.activeSection = 'confirmPassword';
          // }
          createToast(
            {
              title: "Yay!",
              description: response.data['message'] ? response.data['message'] : response.data,
            },
            {
              position: "bottom-right",
              type: "success",
            }
          );
        }).catch((error) => {
          this.activeSection = "confirmPassword";
          Helper.endpointErrorHandling(error);
        });
    }
  }
});
